import { FC, useEffect } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Container } from '@ucheba/ui/components/Container/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { ITimerBannerNewYearDefault } from '../types'
import ImgStar from '../assets/star.png'

const Block = styled.div<StyledProps<any>>`
  background-color: ${sv.color.orange};
  color: ${sv.color.white};
  display: flex;
  position: fixed;
  padding: 10px 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  min-height: 64px;
  cursor: pointer;
`

const TimeWrap = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${sv.color.white};
`

const TimeBlock = styled.div``

const TimeValue = styled.div`
  font-size: ${sv.fontSize.h3};
  font-weight: ${sv.fontWeight.extrabold};
  text-align: center;
  line-height: 1;
  width: 32px;
`

const TimeDots = styled.div`
  width: 8px;
`

const GridWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const ColLeft = styled.div`
  margin-right: 16px;
  flex: 1;
`

const ColRight = styled.div``

const ContainerSC = styled(Container)`
  display: flex;
  align-items: center;
`

const TimeExamWrap = styled.div`
  border-radius: 24px;
  border: 1px solid ${sv.color.white};
  padding: 10px 16px;
  min-width: 280px;
  display: flex;
  justify-content: space-between;
`

const StarImg = styled.img`
  width: 15px;
`

const TimerBannerFixed: FC<ITimerBannerNewYearDefault> = (props) => {
  const {
    seconds,
    hours,
    days,
    minutes,
    title,
    onClick,
    show,
    buttonText,
    prevTimeText,
  } = props

  useEffect(() => {
    document.body.style.paddingBottom = '64px'
  }, [])

  return (
    <Block onClick={onClick}>
      <ContainerSC>
        <GridWrap>
          <ColLeft>
            <Text fontWeight='bold' fontSize='h4'>
              {title}
            </Text>
          </ColLeft>

          <ColRight>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {show && (
                <div>
                  {prevTimeText ? (
                    <div
                      style={{
                        display: 'flex',
                      }}
                    >
                      <div
                        style={{
                          paddingRight: '8px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <StarImg src={ImgStar} />
                      </div>

                      <TimeExamWrap>
                        <TimeBlock>
                          <Text textAlign='center'>
                            {`${prevTimeText} ${days} дн <span style="color: #ffffff80">:</span> ${hours} ч <span style="color: #ffffff80">:</span> ${minutes} мин <span style="color: #ffffff80">:</span> ${seconds} с`}
                          </Text>
                        </TimeBlock>
                      </TimeExamWrap>

                      <div
                        style={{
                          paddingLeft: '8px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <StarImg src={ImgStar} />
                      </div>
                    </div>
                  ) : (
                    <TimeWrap>
                      <TimeBlock>
                        <TimeValue>{days}</TimeValue>

                        <Text
                          textAlign='center'
                          color='white50'
                          fontSize='xsmall2'
                          lineHeight='xsmall2'
                        >
                          дн
                        </Text>
                      </TimeBlock>

                      <TimeDots>
                        <Text
                          textAlign='center'
                          color='gray25'
                          fontSize='h3'
                          lineHeight='small1'
                          fontWeight='bold'
                        >
                          :
                        </Text>
                      </TimeDots>

                      <TimeBlock>
                        <TimeValue>{hours}</TimeValue>

                        <Text
                          textAlign='center'
                          color='white50'
                          fontSize='xsmall2'
                          lineHeight='xsmall2'
                        >
                          ч
                        </Text>
                      </TimeBlock>

                      <TimeDots>
                        <Text
                          textAlign='center'
                          color='gray25'
                          fontSize='h3'
                          lineHeight='small1'
                          fontWeight='bold'
                        >
                          :
                        </Text>
                      </TimeDots>

                      <TimeBlock>
                        <TimeValue>{minutes}</TimeValue>

                        <Text
                          textAlign='center'
                          color='white50'
                          fontSize='xsmall2'
                          lineHeight='xsmall2'
                        >
                          мин
                        </Text>
                      </TimeBlock>

                      <TimeDots>
                        <Text
                          textAlign='center'
                          color='gray25'
                          fontSize='h3'
                          lineHeight='small1'
                          fontWeight='bold'
                        >
                          :
                        </Text>
                      </TimeDots>

                      <TimeBlock>
                        <TimeValue>{seconds}</TimeValue>

                        <Text
                          textAlign='center'
                          color='white50'
                          fontSize='xsmall2'
                          lineHeight='xsmall2'
                        >
                          сек
                        </Text>
                      </TimeBlock>
                    </TimeWrap>
                  )}
                </div>
              )}

              {onClick && (
                <div
                  style={{
                    marginLeft: '16px',
                  }}
                >
                  <Button color='gold' size='small'>
                    {buttonText || 'Отправить заявку'}
                  </Button>
                </div>
              )}
            </div>
          </ColRight>
        </GridWrap>
      </ContainerSC>
    </Block>
  )
}

export default TimerBannerFixed
